import { useEffect, useState } from 'react';
import type { PaymentMethodOption } from '@xshop/shared';
import { fetchApi } from '../api/client';

// The payment methods a store can actually take at checkout, read once per form. Until they arrive, and if they
// cannot be read, the form offers cash on delivery alone, which every store that takes orders offers.

// Reads whether this store takes cards at checkout.
export function useTakesCards(): boolean {
  const [cards, setCards] = useState(false);
  useEffect(() => {
    let live = true;
    fetchApi<PaymentMethodOption[]>('/payments/methods')
      .then((methods) => { if (live) setCards(methods.some((method) => method.provider === 'STRIPE')); })
      .catch(() => undefined);
    return () => { live = false; };
  }, []);
  return cards;
}
